import React, { useEffect, useLayoutEffect } from "react";
import { Modal, Spinner } from 'react-bootstrap';
import { useSelector } from "react-redux";
import { ProgramSetupAxios, UserActivityAxios } from "../../API";
import CdxToolTip from "../../shared/CdxToolTip";
import { Button } from "../../shared/inputs";
import CdxModal from "../../shared/modal/CdxModal";
import PrintPDF from "../../shared/PrintPDF/PrintPDF";
// import Activity from "./TabsComponents/Activity";
import IntroScreen from "./TabsComponents/IntroScreen";
import Reflections from "./TabsComponents/Reflections";
import ThoughtCatalogReport from "./ThoughtCatalogReport";

const ThoughtsCatalog = () => {

    const loggedInUser = useSelector((state) => state.auth.loggedInUser);
    const [showPorgress, setShowProgress] = React.useState(false);
    const [updateSuccess, setUpdateSuccess] = React.useState(false);
    const [show, setShow] = React.useState(false);
    const [showIntro, setShowIntro] = React.useState(true);
    const [showWarning, setShowWarning] = React.useState(false);

    //const [showThought, setShowThought] = React.useState(false);
    const [showActivity, setShowActivity] = React.useState(false);
    const [activeTab, setActiveTab] = React.useState(1);
    const [introDetails, setIntroDetails] = React.useState(null);
    const [catalog, setCatalog] = React.useState([]);
    const [catalogTabs, setCatalogTabs] = React.useState([]);
    const [tabContent, setTabContent] = React.useState([]);
    const [updatedAnswers, setUpdatedAnswers] = React.useState([]);


    const activityLinks = [
        {
            step: 1,
            link: "/files/thought-catalog-activity/1_gearingup.html"
        },
        {
            step: 2,
            link: "/files/thought-catalog-activity/2_joinleague.html"
        },
        {
            step: 3,
            link: "/files/thought-catalog-activity/3_liftoff.html"
        },
        {
            step: 4,
            link: "/files/thought-catalog-activity/4_exploration.html"
        },
        {
            step: 5,
            link: "/files/thought-catalog-activity/5_savetheplanet.html"
        },
        {
            step: 6,
            link: "/files/thought-catalog-activity/6_chartercourse.html"
        }
    ];

    const [oldScrollY, setOldScrollY] = React.useState(0);

    useEffect(() => {
        let old = window.scrollY;
        setOldScrollY(old);
    }, []);

    useEffect(() => {
        ProgramSetupAxios.get('/ThoughtCatalog/getthoughtcatalogbyofferingid/' + loggedInUser.offeringId)
            .then(response => {
                setIntroDetails(response.data);
                setShowProgress(false);
                getTabContent(response.data.id);
            })
            .catch(error => {
                console.log(error);
            });
    }, [show]);

    useEffect(() => {
        let activeContent = tabContent.filter(content => content.sortOrder === activeTab);
        setCatalog(activeContent[0]);
    }, [activeTab, tabContent]);

    useEffect(() => {
        let tabInfo = tabContent.map(content => {
            let tabAnswersCount = content.questions.filter(question => question.answer && question.answer.length > 0).length;
            // console.log("tabQuestionIds", tabAnswersCount);
            let isCompleted = false;
            if (tabAnswersCount === content.questions.length) {
                isCompleted = true;
            }

            return {
                name: content.tabDisplayName,
                id: content.id,
                isCompleted: isCompleted,
                sortOrder: content.sortOrder
            };
        });

        tabInfo.sort((a, b) => (a.sortOrder > b.sortOrder) ? 1 : -1);
        // console.log("tabInfo", tabInfo);

        setCatalogTabs(tabInfo);
    }, [tabContent, updatedAnswers]);

    const toggleShow = () => {
        setShow(!show);
        if (!show) {
            addUserActivityLog("Thought Catalog- Open");
        }
    };

    const handleClose = () => {
        if (updatedAnswers.length > 0) {
            setShowWarning(true);
        }
        else {
            setShow(false);
        }
    };


    const toggleIntroThought = () => {
        setShowIntro(!showIntro);
    };

    const getTabContent = (id) => {
        ProgramSetupAxios.get('/ThoughtCatalog/getthoughtcatalogtabs/' + id)
            .then(function (response) {
                //update activityIFrameLink
                let tabContentData = response.data.map(tab => {
                    return { ...tab, activityIFrameLink: activityLinks.filter(link => link.step === tab.sortOrder)[0].link };
                });

                setTabContent(tabContentData);
                // console.log("tabContent", response.data);
                getReflectionAnswer(tabContentData, loggedInUser.offeringUserId);
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const getReflectionAnswer = (tabData, id) => {
        UserActivityAxios.get('OfferingUserReflectionQuestions/getcataloganswers/' + id)
            .then(function (response) {
                // console.log("reflection answers", response.data);
                setUpdatedAnswers([]);
                mappAnswerWithReflection(tabData, response.data || []);
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const saveAnswers = () => {
        let answers = updatedAnswers.filter(answer => answer.answer !== " ") || [];

        // answers.forEach(answer => {
        UserActivityAxios.post('/OfferingUserReflectionQuestions/postthoughtcataloganswer', answers)
            .then(function (response) {
                getReflectionAnswer(tabContent, loggedInUser.offeringUserId);
                setUpdateSuccess(true);
            })
            .catch(function (error) {
                console.log(error);
            });
        // })
    };

    const mappAnswerWithReflection = (tabData, answer) => {
        // console.log("tabData", tabData);
        let updateTabContent = tabData.map(content => {
            let questions = content.questions.map(question => {
                let answerObj = answer.filter(ans => ans.thoughtCatalogQuestionId === question.id).sort((a, b) => (a.id > b.id) ? -1 : 1);
                if (answerObj.length > 0) {
                    question.answer = answerObj[0].answer;
                }
                return question;
            });

            content.questions = questions;
            // console.log("content", content);
            return content;
        });
        // console.log("updateTabContent", updateTabContent);
        setTabContent(updateTabContent);
    };

    const handleAnswerChange = (questionId, answer) => {
        // console.log("newAnswer", questionId, answer);
        let updateTabContent = tabContent.map(content => {
            let questions = content.questions.map(question => {
                if (question.id === questionId) {
                    question.answer = answer;
                }
                return question;
            });

            content.questions = questions;
            return content;
        });

        let newAnswer = { answer: answer, thoughtCatalogQuestionId: questionId, offeringUserId: loggedInUser.offeringUserId };

        // push to updatedAnswer if not exist
        let newAnswers = updatedAnswers.filter(ans => ans.thoughtCatalogQuestionId !== questionId);
        newAnswers.push(newAnswer);
        setUpdatedAnswers(newAnswers);
        // console.log("updatedAnswers", newAnswers);

        setTabContent(updateTabContent);
        setUpdateSuccess(false);
    };

    // const handleBackButton = () => {
    //     if (showIntro) {
    //         toggleShow()
    //     } else {
    //         setShowIntro(true)
    //     }
    // }

    const Activity = (props) => {

        return (
            <div className={"reflection-item mb-2 " + props.className} id="activity">
                <div className="reflection-item-title">
                    <div className="title-text">Activity</div>
                </div>

                <div className="title-text mb-4">{props.description}</div>
                <div className="avtivity-wrapper">
                    {props.activityLink
                        ? <>
                            <iframe className="activity-frame" src={encodeURIComponent(props.activityLink)} title={props.activityLink} />
                            {/* <object className="activity-frame" data={props.activityLink} type="text/html" >
                                <div className="no-activity">No activity link</div>
                            </object> */}
                        </>
                        : <div className="no-activity">No activity link</div>
                    }
                </div>
            </div>
        );
    };

    const scrollDetect = (e) => {
        console.log("scroll", e);
        var delta = null;

        if (!e) { // if the event is not provided, we get it from the window object
            e = window.event;
        }

        if (e.nativeEvent.wheelDelta) { // will work in most cases
            delta = e.nativeEvent.wheelDelta / 60;
        } else if (e.nativeEvent.detail) { // fallback for Firefox
            delta = -e.nativeEvent.detail / 2;
        }

        if (delta !== null) {
            delta > 0 ? setShowActivity(false) : setShowActivity(true);
        }

    };

    const addUserActivityLog = (value)=>{
        var UAdata = {
            email: loggedInUser.email,
            offeringId: loggedInUser.offeringId,
            missionId: loggedInUser.missionId,
            userId: loggedInUser.userId,
            offeringUserId: loggedInUser.offeringUserId,
            actionType: "Thought Catalog",
            actionName: value,
            actionOn: "",
        };
        UserActivityAxios.post(`UserActivityLog`, UAdata).then(function (res) {

        }).catch(function (error) {
            console.log(error);
        });
    }

    return (
        <div className="thoughts-catalog">
            <CdxToolTip trigger={['hover', 'focus']} content="Thought catalog" >
                <img src="/space/img/CloudIconCircle.svg" alt="" className="pointer" onClick={toggleShow} />
            </CdxToolTip>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                fullscreen={true}
                className="thought-modal"
            >
                <Modal.Header >
                    <div className="branding">
                        <div className="logo-image"></div>
                        <div className="logo-text"></div>
                        <div className="branding-glow" ></div>
                    </div>
                    <div className="modal-close-btn" onClick={handleClose}></div>
                </Modal.Header>
                <Modal.Body>
                    {showPorgress ?
                        <Spinner
                            animation="grow"
                            role="status"
                            aria-hidden="true"
                            variant="primary"
                        />
                        :
                        <>
                            {/* <div className="back-button">
                                <div className="d-flex pointer" onClick={handleBackButton}>
                                    <img src="/space/img/back-icon.svg" alt="" />
                                    <div className="back-button-text">Back</div>
                                </div>
                            </div> */}
                            {showIntro
                                ? <IntroScreen {...introDetails} onClose={toggleIntroThought} />
                                :
                                <>
                                    <div className="thought-catalog-container content-box">
                                        <div className="thought-catalog-tabs">
                                            {catalogTabs && catalogTabs.map((catalogTab, index) => {
                                                return (
                                                    <div className="tabs-wrapper" key={`rnfkji${index}`}>
                                                        <div className="tabs-wrapper-border">
                                                            <div
                                                                className={activeTab === catalogTab.sortOrder ? "tab-item active" : "tab-item"}
                                                                onClick={() => { setActiveTab(catalogTab.sortOrder); setShowActivity(false); }}
                                                                key={"tab-" + catalogTab.id}
                                                            >
                                                                <div className="thought-catalog-tab" key={index}>
                                                                    <div className="thought-catalog-tab-text">{catalogTab.name}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {catalogTab.isCompleted && <div className="completed"></div>}
                                                    </div>


                                                );
                                            })}
                                        </div>
                                        {catalog && <div className="thought-tab-header">
                                            {catalog.qoute &&
                                                <div className="quote-wrapper d-flex">
                                                    <div className="quote">{catalog.qoute}</div>
                                                    <div className="qura-link ps-2"> - {catalog.qouteAuthor}</div>
                                                </div>
                                            }
                                            <div className="quraIcon">
                                                <CdxToolTip content={catalog.curaLinkDesc} className="qura-desc" trigger={['focus', 'click']}>
                                                    <img className={catalog.curaLinkDesc && catalog.curaLinkDesc.length > 0 ? "cura-icon" : "cura-icon disabled"} alt="quraIcon" width="60px" />
                                                </CdxToolTip>
                                            </div>

                                        </div>
                                        }
                                        {catalog &&
                                            <>
                                                <div className="thought-catalog-item" >

                                                    {/* <div className="thought-tab-header">
                                                        {catalog.qoute &&
                                                            <div className="quote-wrapper d-flex">
                                                                <div className="quote">{catalog.qoute}</div>
                                                                <div className="qura-link ps-2"> - {catalog.qouteAuthor}</div>
                                                            </div>
                                                        }
                                                        <CuraIcon description={catalog.qoute} quraDescription={catalog.curaLinkDesc} />

                                                    </div> */}
                                                    {/* <div className="thought-tab-content"> */}
                                                    {/* {
                                                    !showActivity */}
                                                    {!showActivity ?
                                                        <Reflections className={showActivity ? "" : "active"} description={catalog.reflectionDesc} questions={catalog.questions} handleAnswerChange={handleAnswerChange} />
                                                        : <Activity
                                                            className={showActivity ? "active" : ""}
                                                            description={catalog.activityDesc}
                                                            activityLink={catalog.activityIFrameLink}
                                                            questions={catalog.questions} />
                                                    }
                                                    {/* } */}
                                                    {/* </div> */}
                                                </div>
                                                {updateSuccess && (
                                                    <div className="success-message">Updated successfully.</div>
                                                )}
                                                <div className="d-flex align-items-center justify-content-between py-2">


                                                    <Button className="px-5 " onClick={saveAnswers} >Save</Button>
                                                    <a href={showActivity ? "#activity" : "#reflection"} className="scroll-arrow-container" onClick={() => setShowActivity(!showActivity)}>
                                                        <div className={showActivity ? "scroll-down-arrow reverse" : "scroll-down-arrow"} >
                                                            <span></span>
                                                            <span></span>
                                                        </div>
                                                    </a>
                                                    <div>
                                                        <ThoughtCatalogReport
                                                            lable="Export PDF"
                                                            fileName="ThoughtsCatalog"
                                                            loggedInUser={loggedInUser}
                                                            introDetails={introDetails}
                                                            tabContent={tabContent}
                                                            userName={loggedInUser.firstName + " " + loggedInUser.lastName}
                                                            location={loggedInUser.location}
                                                            addUserActivityLog={addUserActivityLog}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </>
                            }
                        </>
                    }
                </Modal.Body>
            </Modal >

            <CdxModal show={showWarning} onHide={() => setShowWarning(false)} animation={false}>
                <CdxModal.Header onClose={() => setShowWarning(false)}>
                    Warning
                </CdxModal.Header>
                <CdxModal.Body>
                    <p>You have not saved the answers. Click Cancel to stay on the page or click Ok to navigate away without saving the answers.</p>
                </CdxModal.Body>
                <CdxModal.Footer>
                    <Button variant="secondary" onClick={() => setShowWarning(false)}>
                        Cancel
                    </Button>
                    <Button variant="secondary" onClick={() => { setShowWarning(false); setShow(false); }}>
                        Ok
                    </Button>
                </CdxModal.Footer>
            </CdxModal>
        </div >
    );
};

export default ThoughtsCatalog;